import { resolveDays, resolveDay } from './resolvers/day.resolver';
import { resolveNestedCategories } from '../event/resolvers/categories.resolver';

export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('app.admin.days', {
            url: '/events/days?:filtertext',
            component: 'dayList',
            resolve: {
                days: resolveDays(),
                categories: resolveNestedCategories('flatten')
            },
            roles: ['manager']
        })
        .state('app.admin.deleteddays', {
            url: '/events/days/deleted',
            component: 'dayList',
            resolve: {
                days: resolveDays(1, 20, 'deleted')
            },
            roles: ['admin']
        })
        .state('app.admin.day-add', {
            url: '/events/days/create',
            component: 'daySave',
            resolve: {
                title: () => 'Create a Spa Day',
                day: resolveDay()
            },
            roles: ['manager']
        })
        .state('app.admin.day-edit', {
            url: '/events/days/:day/update?tab',
            component: 'daySave',
            resolve: {
                title: () => 'Update a Spa Day',
                day: resolveDay()
            },
            roles: ['manager']
        });
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/day.routes.js